export default __webpack_public_path__ + "18c12274.png";